import { makeStyles } from '@material-ui/core';
import { newShadows } from 'muiTheme/config/palette';
import { isMobile, isRtl } from 'helpers/device_helper';

export default makeStyles((theme) => ({
    backDrop: { backdropFilter: 'blur(.8rem)' },
    dialogPaper: {
        padding: '2.4rem',
        borderRadius: '1.2rem',
        maxWidth: '34.3rem',
        boxShadow: newShadows.xl,
        ...isMobile({
            margin: '1.6rem',
        }),
    },
    uploadButton: { height: '4.4rem' },
    subTxt: { color: theme.palette.grayVariants[500], marginBottom: '4rem' },
    header: {
        marginBottom: '.8rem',
        color: theme.palette.grayVariants[900],
        fontWeight: 500,
    },
    iconsContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: '1rem',
    },
    closeButtonWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        position: 'absolute',
        right: '2.4rem',
        ...isRtl({
            right: '0',
            left: '2.4rem',
        }),
    },
    closeButton: { color: theme.palette.grayVariants[500] },
    contentContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
    },
    iconWrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '2rem',
    },
}));
